import React from "react";

const PageTitle = ({ title }) => {
    return (
        <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-700">{title}</h2>

            {/* {subtitle && (
                <p className="text-gray-500 text-sm mt-1">
                    {subtitle}
                </p>
            )} */}

            <div className="h-[2px] w-16 bg-indigo-600 rounded-full"></div>
        </div>
    );
};

export default PageTitle;
